import { Outlet } from 'react-router-dom';
import { usePageTitle } from '../../hooks/usePageTitle';
import { Header } from './Header';
import { SideMenu } from './SideMenu';

/**
 * Layout — shell that wraps all authenticated pages via React Router.
 * Mirrors the outer structure of atss-manage-web/views/_base-layout.ejs.
 */
const Layout: React.FC = () => {
  usePageTitle();

  return (
    <div className="d-flex vh-100">
      <SideMenu />
      <div className="layout__content">
        <Header />
        <main className="layout__main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
